<template>
    <app-layout class="disabled">
        <Head>
            <title>Dashboard</title>
        </Head>

        <template v-slot:overline>
            <translate>Willkommen</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <modal width="small">
            <modal-header>
                <translate>Ihre Registrierung bei PART FACTORY</translate>
            </modal-header>
            <modal-content>
                <h5><translate>Guten Tag</translate> {{ this.$page.props.user.name }}</h5>
                <p><translate>herzlich willkommen und vielen Dank für Ihre Anmeldung bei PART FACTORY.</translate></p>
                <p><translate :translate-params="{email: this.$page.props.user.email}">Bitte bestätigen Sie die bei Ihrer Registrierung angegebene E-Mail-Adresse. Wir haben Ihnen eine Email mit dem Bestätigungslink an <strong>%{email}</strong> gesendet</translate></p>
            </modal-content>
            <modal-actions :disable-close="true">
                <div class="row" style="max-width: 80%; margin: 0 auto; ">
                    <div class="col col-6">
                        <form-link-button :route="this.$$route('verification.resend')" color="secondary" class="btn--block" icon="email-mail-checkmark" >
                            <translate>Email erneut senden</translate>
                        </form-link-button>
                    </div>
                    <div class="col col-6">
                        <form-link-button :route="this.$$route('logout')" class="btn--block" icon="lock-unlock" >
                            <translate>Logout</translate>
                        </form-link-button>
                    </div>
                </div>
            </modal-actions>
        </modal>

        <div class="dashboard">
            <div class="dashboard--tabs">
                <nav>
                    <ul>
                        <li>
                            <dashboard-tab icon="user-profile-square" active="true">
                                <translate>aktive<br/>Angebote</translate>
                            </dashboard-tab>
                        </li>
                        <li>
                            <dashboard-tab icon="user-profile-square">
                                <translate>neue<br/>Bestellungen</translate>
                            </dashboard-tab>

                        </li>
                        <li>
                            <dashboard-tab icon="user-profile-square">
                                <translate>laufende<br/>Anfragen</translate>
                            </dashboard-tab>
                        </li>
                        <li>
                            <dashboard-tab icon="user-profile-square">
                                <translate>laufende<br/>Bestellungen</translate>
                            </dashboard-tab>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="dashboard--content">
                <dashboard-dummy />
            </div>
        </div>
    </app-layout>

</template>
<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import DashboardTab from '@partfactory/Pages/Client/Dashboard/DashboardTab';
import DashboardDummy from '@partfactory/Pages/Client/Dashboard/DashboardDummy';
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';

export default {
    name: 'ClientDashboard',
    components: {
        ModalActions,
        FormLinkButton,
        ModalHeader,
        ModalContent,
        Modal,
        DashboardDummy,
        DashboardTab,
        AppLayout,
    },
    props: {
        user: Object,
        runningAskForQuotes: Object,
        activeOffers: Object,
        runningOrders: Object,
        newOrders: Object,
    },
    data() {
        return {
            currentCard: {
                0: true,
                1: false,
                2: false,
                3: false
            },
        };
    },
};
</script>
